import { Select } from '../../../shared/components';
import { AuditFilters } from '../../../shared/services/audit/types';
import { ParamUser } from '../../../shared/services/settings/types';

const ACTION_OPTIONS = [
  { value: 'UPDATE', label: 'Modificado' },
  { value: 'DELETE', label: 'Eliminado' },
];

export function AuditFiltersBar({ value, onChange, users }: { value: AuditFilters; onChange: (v: AuditFilters) => void; users: ParamUser[] }) {
  const update = (patch: Partial<AuditFilters>) => onChange({ ...value, ...patch });

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <label className="block">
        <input
          type="date"
          value={value.dateFrom ?? ''}
          onChange={(e) => update({ dateFrom: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <label className="block">
        <input
          type="date"
          value={value.dateTo ?? ''}
          onChange={(e) => update({ dateTo: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <Select placeholder="Cualquier novedad" options={ACTION_OPTIONS} value={value.action ?? ''} onChange={(e) => update({ action: (e.target.value || undefined) as AuditFilters['action'] })} />
      <Select
        placeholder="Cualquier usuario"
        options={users.map((u) => ({ value: u.fullName, label: u.fullName }))}
        value={value.performedBy ?? ''}
        onChange={(e) => update({ performedBy: e.target.value || undefined })}
      />
    </div>
  );
}
